import { Component,OnInit } from '@angular/core';
import { NavParams,LoadingController,ToastController,AlertController } from 'ionic-angular';
import { DTOCheckCatalogo } from '../../dto/dtoCheckCatalogo';
import { DTOListaCatalogo } from '../../dto/dtoListaCatalogo';
import { PedidoDAO } from '../../daos/pedido-dao';
import { AppModule } from '../../app/app.module';


@Component({
    selector: 'page-cadastro-referencia-manter',
    templateUrl: 'cadastro-referencia-manter.html'
})
export class CadastroReferenciaManterPage implements OnInit{
    public listaCheckCatalogo: DTOCheckCatalogo[] = [];
    public dtoListaCatalogo : DTOListaCatalogo;
    public qtdePicotes: number;
    public estaEditando: boolean = false;
    public objReferencia: string;
    paramCodReferencia: string;
    paramDescReferencia: string;
    searchTerm: string;


    constructor(private _loadingCtrl: LoadingController,_navParams: NavParams,
        private _toastCtrl: ToastController,private _alertCtrl: AlertController,
        private _pedidoDAO: PedidoDAO) {  
            this.dtoListaCatalogo = _navParams.get('dtoListaCatalogo');  
            this.qtdePicotes = _navParams.get('qtdePicotes');
            
            if (this.dtoListaCatalogo)  {
                this.paramCodReferencia = this.dtoListaCatalogo.Referencia;
                this.paramDescReferencia = this.dtoListaCatalogo.Descricao;
                this.estaEditando = true;
            }
 
    }

    ngOnInit(): void {
        if (this.dtoListaCatalogo)  {
            this.obterCatalogo(this.dtoListaCatalogo.Referencia);    
        }
    }

    public obterCatalogo(referencia: string): void { 
        console.log(referencia);
        let load = this._loadingCtrl.create({ content: 'Obtendo referência...' });
        load.present();
        this._pedidoDAO.listaCheckCatalogo(AppModule.getEmpresa().Id,referencia).then(lista => {    

        this.listaCheckCatalogo = lista; 

        load.dismiss();
        }).catch(error => {
        this._toastCtrl.create({
            message: 'Ocorreu um erro ao tentar obter catalogo. Tente novamente!',
            duration: 3000
        }).present();
        console.error(error);
        load.dismiss();
        });  
        
    }

    removeRegistro(redProduto: number, referencia: string):void {
        this._pedidoDAO.DeletarReferencia(AppModule.getEmpresa().Id,redProduto)
                  .then(retorno => {
                    
                    //
                    if (retorno=='ok'){
                        this.obterCatalogo(referencia); 
                        this.alertaDeSucesso('Referência removida com sucesso');
                        //this._viewCtrl.dismiss(true);
                    }   
        
        
                  }, e => {
                      console.error('Não foi possível adicionar a referência.');
            }
        );     
    }


    adicionarReferencia(redProduto: number, referencia: string):void{
            this._pedidoDAO.AddReferencia(AppModule.getEmpresa().Id,redProduto,this.qtdePicotes)
                  .then(retorno => {
                    
                    //this.dtoListaCatalogo.Referencia
                    if (retorno=='ok'){
                        this.obterCatalogo(referencia); 
                        this.alertaDeSucesso('Cadastro efetuado com sucesso');
                        //this._viewCtrl.dismiss(true);
                    }   
        
        
                  }, e => {
                      console.error('Não foi possível adicionar a referência.');
            }
        );    
   
      
    }

    alertaErro(msg: string) {
        this._alertCtrl.create({
            message: msg,
            title: 'Ops... 😔',
            buttons: [{
                text: 'Ok, estou ciente'
            }]
        }).present();
    }


    alertaDeSucesso(msg: string) {
      this._alertCtrl.create({
          message: msg,
          title: 'Sucesso 😀 ️',
          buttons: [{
              text: 'Ok'
          }]
      }).present();
    }

    
    

}


// WEBPACK FOOTER //
// ./src/pages/cadastro-referencia-manter/cadastro-referencia-manter.ts